import { render, staticRenderFns } from "./LearnAboutMonetizationPrompt.vue?vue&type=template&id=50348f76&scoped=true"
import script from "./LearnAboutMonetizationPrompt.vue?vue&type=script&lang=js"
export * from "./LearnAboutMonetizationPrompt.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutMonetizationPrompt.vue?vue&type=style&index=0&id=50348f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50348f76",
  null
  
)

export default component.exports